<template>
    <div class="rodemap">
        <div class="mask05"></div>
        <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
    </div>
</template>

<script>
    //script
    import Tools from '../../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../../scripts/Global';

    import QuestionSelect from '../../cmp/questionSelect';

    export default {
        data() {
            return {
                data: {
                    headTipImg: '',
                    headTipTxt: '',
                    headTipPathTxt: '前往钦安殿 >>',
                    headTipPath: '/rodemap/aj/05',
                    headTipStyle: {
                        bottom: '-1rem',
                    },
                    qText: '这是镇守天一门的金獬豸，找出图中共有几处不同，我就带你进钦安殿',
                    qImg: '3处不同',

                    errText:
                        '这是镇守天一门的金獬豸，找出图中共有几处不同，我就带你进钦安殿',
                    okText:
                        '这是镇守天一门的金獬豸，找出图中共有几处不同，我就带你进钦安殿',

                    answerArr: [
                        {
                            txt: '四 处',
                        },
                        {
                            txt: '三 处',
                            right: true,
                        },
                    ],
                },
            };
        },
        components: {
            QuestionSelect,
        },
        created() {
            Global.startPlay('aj', 'scene6');
        },
        computed: {},
        methods: {
            jump(event) {
                if (event) {
                } else {
                    this.$router.replace('/rodemap/aj/05');
                }
                console.log(event, 'event');
            },
            finish(event) {
                if (event) {
                    Global.curr = {
                        ...this.data,
                        headTipImg: 'cv-03',
                        headTipTxt: '不错，智商还在线。拿好这个，走吧',
                        headTipPath: '/rodemap/aj/05',
                        headTipPathTxt: '前往钦安殿 >>',
                        ybtxt: '',
                        bg: '天一门',
                        textCfg: {
                            'text-align': 'center',
                        },
                    };
                    Global.yubi.aj.b2 = true;
                    this.$router.replace('/yu');
                    Global.startPlay('aj', 'scene7');
                } else {
                    this.$router.replace('/rodemap/aj/04_5');
                }
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/天一门.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
